import { Typography } from '@mui/material';
import JobStatus from '@product-framework/components/JobStatus';
import ReadMoreText from '@ui-framework/components/UI/ReadMoreText';
import { DATE_FORMAT } from '@ui-framework/index';
import dayjs from 'dayjs';
import { Link } from 'react-router-dom';

function serviceJobNumber(original) {
  const editLink = `/servicejobs/edit/${original?.id}`;
  const registerLink = `/servicejobs/register/${original?.id}`;
  return (
    <Link to={original?.serviceJobForm?.id ? editLink : registerLink}>
      {original?.serviceJobNumber || ''}
    </Link>
  );
}

function customerName(original) {
  const first = original?.customerNameFirst || '';
  const last = original?.customerNameLast || '';
  return `${first} ${last}`.trim();
}

function customerServiceRequests(original) {
  return original?.customerServiceRequests?.map(row => (
    <Typography variant="body2" key={JSON.stringify(row)}>
      {row?.requestDate
        ? dayjs(row?.requestDate).format(DATE_FORMAT.MEDIUM_DATE)
        : ''}
    </Typography>
  ));
}

function customerAddressCity(original) {
  return original?.customerAddressCity || '';
}

function customerAddressState(original) {
  return original?.customerAddressState?.name || '';
}

function customerAddressPostalCode(original) {
  return original?.customerAddressPostalCode || '';
}

function productType(original) {
  return original?.productType?.productLineName || '';
}

function brand(original) {
  return original?.brand?.brandName || '';
}

function customerComplaint(original) {
  return <ReadMoreText>{original?.customerComplaint}</ReadMoreText>;
}

function appointmentDate(original) {
  return original?.appointmentDate
    ? dayjs(original.appointmentDate).format(DATE_FORMAT.MEDIUM_DATE)
    : '';
}

function serviceJobStatus(original) {
  return <JobStatus>{original?.serviceJobStatus}</JobStatus>;
}

export {
  serviceJobStatus,
  serviceJobNumber,
  customerName,
  customerServiceRequests,
  customerAddressCity,
  customerAddressState,
  customerAddressPostalCode,
  productType,
  brand,
  customerComplaint,
  appointmentDate,
};
